import React, { useEffect, useRef } from 'react';
import widgetRender from './bei-light';

function test2(data, action) {
  // json parametres de la viz
  const widgetProperties_pie = {
    generalProperties: {
      chartType: 'pie', // barchart, pie, linechart
      orientation: 'horizontal', // horizontal, vertical (for XY axis chart)
      direction: 'standard', // standard, opposite
      margin: { top: 20, right: 30, bottom: 10, left: 30 },
      size: { width: '100%', height: '100%' },
      minSize: { width: 150, height: 200 },
      activeClipPath: false,
      errorMsg: 'lorem ipsum'
    },
    detailProperties: {
      dataAggregation: false,
      dimensionFields: ['type'],
      dimensionFieldsDatatype: ['text'],
      calculationFields: ['cout'],
      calculationFieldsDatatype: ['number'],
      calculationFieldsFormat: ['.0f'],
      styles: {
        themeScheme: 'beiLightTheme',
        colors: {
          defaultColor: '#ffb21e',
          defaultStrokeColor: '#ffb21e',
          defaultFillColor: '#ffb21e',
          dimensionField: ['index'],
          dimensionFieldSortOrder: null,
          dimensionFieldCustomOrder: null,
          dimensionScaleMode: ['categorical'], // categorical, continous
          scaleType: 'scaleOrdinal', // scaleLinear, scaleSequential, scaleTreshold, scaleOrdinal
          interpolator: null,
          scheme: ['#334679', '#B9F5E5', '#B3E5AC', '#FFE897', 'red'],
          schemeType: 'colorArray' // colorArray, colorGradientArray
        },
        textures: {
          active: false,
          defaultTexture: ''
        }
      },
      pieChart: {
        pieType: 'standard', // gauge : only 1 value, standard (multiples values)
        fieldSort: '__calc__',
        fieldSortOrder: 'desc',
        hPosition: 'center',
        vPosition: 'centerViz',
        hPadding: 0,
        vPadding: 0,
        pieBackgroundColor: '#ededed',
        pieBackgroundTextureScheme: 'lines',
        gaugeLabelUnderline: false,
        labelAltPadding: 20,
        labelLine: true,
        labelLineLength: 120,
        labelLineColor: '#000000',
        labelLineWidth: 0.5,
        labelLinePadding: 5,
        outerRadius: 0.6,
        innerRadius: 0.4,
        cornerRadius: 0,
        // 'startAngle' : -115,
        // 'endAngle' : 115,
        padAngle: 0.02
      },
      picto: {
        pictos: []
      },
      label: {
        visible: true,
        text: '[__pct__]',
        position: 'shape', // top, bottom, left, right, center ,shape
        relativePosition: 'outside',
        padding: 20,
        vPadding: 0,
        hPadding: 0,
        fontFamily: 'Montserrat',
        fontSize: '16px',
        fontWeight: '500',
        textAnchor: 'middle',
        color: '#666666',
        altColor: '#000000',
        dy: '0.35em',
        prefix: '',
        suffix: '%',
        suffixFontSize: '12px',
        suffixFontWeight: '500',
        suffixDy: '-0.35em',
        suffixColor: '#666666',
        variableFormat: {
          __value__: {
            datatype: 'number',
            formatOut: '.2~f',
            removeFormatPctSign: false
          },
          __pct__: {
            datatype: 'number',
            formatOut: '.1~%',
            removeFormatPctSign: true
          }
        }
      },
      title: {
        visible: false,
        text: 'VALUATION METHODOLOGIES USED',
        hPosition: 'left',
        vPosition: 'top',
        hPadding: 20,
        vPadding: 10,
        alignment: 'center',
        fontFamily: 'Montserrat',
        color: '#485465',
        fontSize: '16px',
        fontWeight: '800',
        textAnchor: 'start',
        SVG: null
      },
      caption: {
        text: '',
        hPosition: 'center',
        vPosition: 'bottom',
        padding: 30,
        alignment: 'center',
        fontFamily: 'Montserrat',
        color: '#535353',
        fontSize: '12px',
        fontWeight: 'normal',
        fontStyle: 'italic',
        textAnchor: 'middle',
        SVG: null
      },
      legend: {
        type: 'data', // manual, data, dimension, measure
        scaleMode: 'categorical', // null, categorical, continous
        marker: 'square', // square, roundedSquare, circle, line
        markerSize: 14,
        text: null,
        orientation: 'horizontal',
        hPosition: 'centerViz',
        vPosition: 'bottom',
        hPadding: 0,
        vPadding: 15,
        alignment: 'center',
        fontFamily: 'Montserrat',
        padding: 0,
        color: '#535353',
        fontSize: '12px',
        fontWeight: '400',
        fontStyle: 'normal',
        textAnchor: 'start',
        blockPadding: 20,
        maxBlockPerRow: 3,
        minBlockSize: 100,
        // 'SVG' : "<g class='element'><text dy='0.9em'><tspan>[type] </tspan><tspan x='140' style='text-anchor:end;font-weight:600'>[__pct__]</tspan></text></g>",
        SVG:
          '<g class=\'element\'><text dy=\'0.9em\'><tspan>[type] </tspan></text></g>',
        // 'SVG' : null,
        variableFormat: {
          cout: {
            datatype: 'number',
            formatOut: '$,.2d',
            removeFormatPctSign: false
          },
          __pct__: {
            datatype: 'number',
            formatOut: '.1~%',
            removeFormatPctSign: false
          }
        }
      },
      animation: {
        active: true,
        duration: 1500,
        delay: 0,
        incrementalDelay: 0,
        ease: 'easeCubic' // default : easeCubic, easeLinear, easeBounce, easeElastic, easeExp, easeCircle
      },
      events: {
        mouseover: true,
        click: false
      }
    },
    contextualProperties: {
      tagId: 'ChartValuationMethodo',
      dataIn: data
    }
  };

  widgetRender(widgetProperties_pie, action);
}

const ChartValuationMethodo = ({ data, loading, error }) => {
  const d3svg = useRef(false);

  /*   useEffect(() => {
    }, [loading]); */

  useEffect(() => {
    if (d3svg.current && data) {
      const cnt = data.length;
      if (cnt !== 0) {
        test2(data, 'init');
      }
    } else d3svg.current = true;
  }, [data]);

  return (
    <>
      <div
        ref={d3svg}
        className="bar-chart-container"
        id="ChartValuationMethodo"
        role="img"
        style={{ width: '100%', height: '300px' }}>
        {loading && <h4>Loading...</h4>}
        {error && <h4>{error}</h4>}
      </div>
    </>
  );
};

export default ChartValuationMethodo;

// style={{ pointerEvents: 'all', width: '100%', height: '100%' }}
